import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Tooltip,
  Typography,
  useTheme,
  IconButton,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ICivilAviationList } from "src/Types/module/UpdateRequest/RequestCivilAviation";
import { getStatusLabel } from "src/Utils/Combined";

interface IProps {
  isLoading: boolean;
  civilAviationInfo: ICivilAviationList[];
}
const CivilAviationIndex = ({ isLoading, civilAviationInfo }: IProps) => {
  const theme = useTheme();
  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Company Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableLoader />
            ) : civilAviationInfo.length ? (
              <>
                {civilAviationInfo.map((sCivilAviationInfo) => {
                  return (
                    <TableRow hover key={sCivilAviationInfo.request_id}>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sCivilAviationInfo.member_company_id}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sCivilAviationInfo.member_company_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {getStatusLabel(sCivilAviationInfo.status)}
                      </TableCell>
                      <TableCell>
                        <Link
                          to={`/update-request/civil-aviation/${sCivilAviationInfo.request_id}?memberid=${sCivilAviationInfo.user_member_id}`}
                        >
                          <Tooltip title="View" arrow={true}>
                            <IconButton
                              sx={{
                                "&:hover": {
                                  background: theme.colors.primary.lighter,
                                },
                                color: theme.palette.primary.main,
                              }}
                              color="inherit"
                              size="small"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <TableNotFound />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default CivilAviationIndex;
